import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastSheetGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'sheetname', headerName: 'Sheet', width: 220, flex: 1, minWidth: 220 },
    { field: 'datasetcode', headerName: 'Dataset', width: 150 },
    { field: 'rowcount', headerName: 'Rows', width: 100, type: 'number' },
    { field: 'mappedcount', headerName: 'Mapped', width: 110, type: 'number' },
    { field: 'errorcount', headerName: 'Errors', width: 100, type: 'number' },
    { field: 'status', headerName: 'Status', width: 130, renderCell: ForecastStatusChip },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || `${row.batchcode}-${row.sheetname}-${row.datasetcode}`;

  render() {
    return (
      <FDataGrid
        title="Forecast Sheets"
        subtitle="Workbook sheets and detected datasets."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={330}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#f5f7fa' }}
        getRowId={this.getRowId}
        onRowClick={(p:any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[10,25,50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastSheetGrid;
